import {
  deleteControls,
  getInProgressState,
  refreshDeviceStatus,
} from "../../redux/voiceControl-slice";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../components";
import { Dialog } from "../../components";
import cn from "classnames";
import { deviceStatus } from "../../constants/voice";
import { getSelectedDeviceData } from "../../redux/voiceControl-slice";
import styles from "./VoiceControlsStatusMessage.module.scss";
import { useFormatMessage } from "../../i18n";
import { useState } from "react";

const errorMessages = {
  VOICE_INVALID_DEVICE: "error_voice_invalid_device",
  NOT_FOUND: "error_device_not_found",
  VOICE_INVALID_STATE: "error_voice_invalid_state",
  GATEWAY_TIMEOUT: "error_device_time_out",
  SERVER_ERROR: "something_went_wrong",
};

export function VoiceControlsStatusMessage() {
  const [showModal, setShowModal] = useState(false);
  const deviceSelected = useSelector(getSelectedDeviceData);
  const { deleteInProgress } = useSelector(getInProgressState);
  const tr = useFormatMessage();
  const dispatch = useDispatch();

  function handleDeleteControls() {
    dispatch(deleteControls(deviceSelected.cloudId));
    setShowModal(false);
  }

  function handleRefreshDevice() {
    dispatch(refreshDeviceStatus(deviceSelected.cloudId));
  }

  const errorMessage = tr(
    errorMessages[deviceSelected.error || "SERVER_ERROR"]
  );

  const infoMessages = {
    unselected: {
      icon: deviceStatus["unselected"],
      message: "info_device_unselected",
    },
    checking: {
      icon: deviceStatus["checking"],
      message: "info_device_checking",
      className: styles.checking,
    },
    offline: {
      icon: deviceStatus["offline"],
      message: "info_device_offline",
      className: styles.offline,
    },
    invalid_device: {
      icon: deviceStatus["invalid_device"],
      message: "info_device_firmware",
      className: styles.error,
    },
    invalid_firmware: {
      icon: deviceStatus["invalid_firmware"],
      message: "info_device_firmware",
      className: styles.error,
    },
    reprogrammed: {
      icon: deviceStatus["reprogrammed"],
      message: "info_device_reprogrammed",
      className: styles.error,
    },
    empty: {
      icon: deviceStatus["empty"],
      message: "info_device_empty",
    },
    generic_error: {
      icon: deviceStatus["generic_error"],
      message: errorMessage,
      className: styles.error,
    },
  };

  const canRefresh = [
    "offline",
    "invalid_device",
    "invalid_firmware",
    "empty",
    "generic_error",
  ];

  function setInfoMessage() {
    const infoMessage = deviceSelected.status
      ? infoMessages[deviceSelected.status]
      : infoMessages["unselected"];
    if (infoMessage) {
      return infoMessage;
    }
    return infoMessages.generic_error;
  }

  const canDelete = ["reprogrammed"];
  const infoMessage = setInfoMessage();

  return (
    <div className={styles.voiceControlsStatusMessage}>
      <div className={cn(styles.statusIcon, infoMessage.className)}>
        {infoMessage?.icon}
      </div>
      <div className={styles.textMessage}>{tr(infoMessage.message)}</div>

      {canDelete.includes(deviceSelected.status) && (
        <Button
          loading={deleteInProgress}
          type="submit"
          title={tr("device_delete_controls_button")}
          disabled={deleteInProgress}
          variant="danger"
          onClick={() => {
            setShowModal(true);
          }}
        />
      )}
      {canRefresh.includes(deviceSelected.status) && (
        <Button
          loading={false}
          type="submit"
          title={tr("device_refresh_button")}
          disabled={false}
          variant="primary"
          onClick={handleRefreshDevice}
        />
      )}
      <Dialog
        content={tr(
          "this_operation_is_not_reversible_are_you_sure_you_want_to_delete_all_your_controls"
        )}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        buttons={[
          {
            title: tr("no_go_back"),
            handler: () => setShowModal(false),
            variant: "light",
          },
          {
            title: tr("yes_i_want_to_proceed"),
            handler: handleDeleteControls,
            variant: "danger",
          },
        ]}
      />
    </div>
  );
}
